import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose, withProps } from 'recompose';
import { getUiOptions } from 'react-jsonschema-form/lib/utils';

import isEmpty from 'lodash/isEmpty';
import BaseObjectField from '../BaseObjectField';
import { withStyles } from 'material-ui/styles';
import { FormControl } from 'material-ui/Form';
import { TableCell, TableRow } from 'material-ui/Table';

const styles = theme => ({
  noBorder: {
    border: 0,
  },
  labelCell: {
    verticalAlign: 'top',
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit * 2,
    whiteSpace: 'unset',
  },
  cell: {
    overflow: 'unset',
  },
  cellPadRight: {
    paddingRight: theme.spacing.unit * 2,
    '@media(max-width:760px)': {
      paddingRight: theme.spacing.unit,
    },
  },
  cellLabel: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  error: {
    color: theme.palette.error['A400'],
  },
  row: {
    height: 'auto',
  },
});

const TableRowComponent = props => {
  const {
    classes,
    columns,
    schema,
    errorSchema,
    uiSchema,
    formContext,
    children,
    options = getUiOptions(uiSchema),
    name,
  } = props;

  const { validatorKey } = options;
  const hasError = !isEmpty(errorSchema);
  const formControlState = formContext.formControlStates[validatorKey];
  const shouldShowError =
    hasError && (formControlState.dirty || formContext.shouldStrictValidate);

  const needsExtraRow = columns && columns <= children.length;
  const title = schema.title === undefined ? name : schema.title;

  const renderCell = (child, index) => {
    const isLastCell = needsExtraRow && index + 1 >= columns;
    const cellProps =
      isLastCell || children.length < columns - 1 ? { colSpan: 2 } : {};
    const cellClass = classnames(classes.cell, {
      //[classes.noBorder]: !isLastCell && needsExtraRow,
      [classes.noBorder]: needsExtraRow && index < children.length - 1,
      [classes.cellPadRight]: needsExtraRow && index === children.length - 2,
    });
    return (
      <TableCell
        key={index}
        {...cellProps}
        padding="none"
        className={cellClass}
      >
        {child}
      </TableCell>
    );
  };

  const renderCellWithRowWrap = (child, index) => {
    return (
      <TableRow className={classes.row} key={index}>
        {child}
      </TableRow>
    );
  };

  const cells = children.map((child, index) => {
    return renderCell(child, index);
  });

  const labelCellProps = /*needsExtraRow ? { rowSpan: 2 } : */ {};
  const renderLabelCell = () => (
    <TableCell
      {...labelCellProps}
      padding="none"
      className={classnames(classes.labelCell, {
        [classes.noBorder]: needsExtraRow,
      })}
    >
      <FormControl
        className={classnames(classes.cellLabel, {
          [classes.error]: shouldShowError,
        })}
      >
        {uiSchema['ui:title'] || title}
      </FormControl>
    </TableCell>
  );

  return !needsExtraRow ? (
    <TableRow>
      {renderLabelCell()}
      {cells}
    </TableRow>
  ) : (
    [
      <TableRow key="row-extra">
        {renderLabelCell()}
        {cells.slice(0, cells.length - 1)}
      </TableRow>,
      renderCellWithRowWrap(cells[cells.length - 1], cells.length - 1),
    ]
  );
};

TableRowComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  columns: PropTypes.number,
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object.isRequired,
  errorSchema: PropTypes.object.isRequired,
  options: PropTypes.object,
  formContext: PropTypes.object.isRequired,
  name: PropTypes.string,
};

const enhance = compose(
  withProps({
    RootComponent: withStyles(styles)(TableRowComponent),
  })
);

const TableRowField = enhance(BaseObjectField);

export default TableRowField;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/readonly/TableRowField.js